import {
    DataTexture,
    CubeTexture,
    RGBAFormat,
    LogLuvEncoding,
    LinearMipmapLinearFilter,
    LinearFilter,
    Vector3,
    ClampToEdgeWrapping
} from "three"
// import {Zlib} from '../jsm/libs/gunzip.module.min'
var zlib = window.Zlib;
class EnvironmentCubeMap {
    constructor(urlOrData, size, options) {
        this._options = options || {};
        this._size = size;
        if (typeof urlOrData === 'string') this._file = urlOrData;
        else this._data = urlOrData;
    }
    isGunzipBuffer(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        return typedArray[0] === 0x1f && typedArray[1] === 0x8b;
    };
    gunzip(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        // var zlib = require('zlib');
        if (!zlib) {
            console.error('zlib is not exit')
        }
        var zdec = new zlib.Gunzip(typedArray);
        var result = zdec.decompress();
        return result.buffer;
    }
    loadPacked() {
        let self = this;
        var readInputArray = function (inputArray) {
            var data = inputArray;
            if (self.isGunzipBuffer(data))
                data = self.gunzip(data);

            var maxLevel = Math.log(self._size) / Math.LN2;
            var offset = 0;
            var images = {};
            for (var i = 0; i <= maxLevel; i++) {
                var size = Math.pow(2, maxLevel - i);
                var byteSize;
                if (offset >= data.byteLength) break;
                for (var face = 0; face < 6; face++) {
                    // addcreateRGBA8Packed entry if does not exist
                    if (!images[face]) images[face] = [];

                    var imageData;
                    var deinterleave;
                    byteSize = size * size * 4;
                    imageData = new Uint8Array(data, offset, byteSize);
                    deinterleave = new Uint8Array(byteSize);
                    self.deinterleaveImage4(size, imageData, deinterleave);
                    imageData = deinterleave;
                    images[face].push(imageData);
                    offset += byteSize;
                }
            }
            self._packedImages = images;

            return self.createRGBA8Packed();


        }
        return readInputArray(this._data);
    }
    createRGBA8Packed() {
        var cubeTextureData = [];
        var size0 = this._size;
        for (var i = 0; i < this._packedImages[0].length; i++) {
            var images = [];
            for (var j = 0; j < 6; j++) {
                var texture = new DataTexture(this._packedImages[j][i], size0, size0, RGBAFormat);
                texture.format = RGBAFormat;
                texture.encoding = LogLuvEncoding;
                texture.minFilter = LinearMipmapLinearFilter;
                texture.needsUpdate = true;
                images.push(texture);
            }
            var cubemap0 = new CubeTexture(images);
            cubemap0.format = RGBAFormat;
            cubemap0.encoding = LogLuvEncoding;
            cubemap0.minFilter = LinearFilter;
            cubemap0.minFilter = LinearMipmapLinearFilter;
            cubemap0.needsUpdate = true;
            cubeTextureData.push(cubemap0);
            size0 = size0 / 2;
        }

        var envMap = cubeTextureData.shift();
        envMap.format = RGBAFormat;
        var cubeTextureMipMaps = cubeTextureData;
        envMap.mipmaps = cubeTextureMipMaps;
        // envmap.minFilter=THREE.LinearFilter;
        envMap.minFilter = LinearMipmapLinearFilter;
        envMap.magFilter = LinearFilter;
        envMap.wrapS = ClampToEdgeWrapping;
        envMap.wrapT = ClampToEdgeWrapping;
        envMap.encoding = LogLuvEncoding;
        envMap.generateMipmaps = false;
        envMap.needsUpdate = true;
        this.cubeMap = envMap;
        return envMap;

    }
    deinterleaveImage4(size, src, dst) {
        var npixel = size * size;
        var npixel2 = 2 * size * size;
        var npixel3 = 3 * size * size;
        var idx = 0;
        for (var i = 0; i < npixel; i++) {
            dst[idx++] = src[i];
            dst[idx++] = src[i + npixel];
            dst[idx++] = src[i + npixel2];
            dst[idx++] = src[i + npixel3];
        }
    }


    deinterleaveImage3(size, src, dst) {
        var npixel = size * size;
        var idx = 0;
        for (var i = 0; i < npixel; i++) {
            dst[idx++] = src[i];
            dst[idx++] = src[i + npixel];
            dst[idx++] = src[i + 2 * npixel];
        }
    }

}
export default EnvironmentCubeMap